export default __webpack_public_path__ + "static/media/ViewAllInterviews.6598ab7e.svg";